import { db, UserCache } from '@/db/db';
import { getExistingDocOnIndexeddb, updateTitleInCache } from '@/db/queries';
import { TGunUserNode } from '@/types';
import { ARCH_VERSION } from '@/utils/constants';
import { getDdocDataByNodeKey } from '@/utils/gun-utils';
import { WorkerInstance } from '@/utils/worker-utils/worker-instance';

export const attemptTitleDecryption = async (
  cachedDdoc: UserCache,
  walletAddress: string,
  userNode?: TGunUserNode
) => {
  if (!cachedDdoc) return '';

  const {
    encryptedTitle,
    linkKeyNonce,
    linkKey,
    ddocId,
    archVersion,
    ownerLock,
  } = cachedDdoc;

  // check the decrypted title first and then compare it with the cache

  if (cachedDdoc.title && !cachedDdoc.needToDecryptTitle)
    return cachedDdoc.title;

  if (
    ownerLock &&
    ownerLock.lockedFileKey &&
    archVersion === ARCH_VERSION &&
    encryptedTitle
  ) {
    const decryptedTitle = await WorkerInstance.decryptTitle(
      ownerLock,
      encryptedTitle
    );

    if (decryptedTitle) {
      await updateTitleInCache(walletAddress, ddocId, decryptedTitle);

      const existingDoc = await getExistingDocOnIndexeddb(ddocId);
      if (existingDoc) {
        await db.ddocs.put({
          ...existingDoc,
          title: decryptedTitle,
        });
      }
    }
    return decryptedTitle;
  }

  if (encryptedTitle && linkKey && linkKeyNonce) {
    const decryptedTitle = await WorkerInstance.decryptDdocTitle(
      encryptedTitle,
      ddocId,
      linkKeyNonce,
      linkKey
    );
    if (decryptedTitle) {
      await updateTitleInCache(walletAddress, ddocId, decryptedTitle);
    }
    return decryptedTitle;
  }

  if (userNode) {
    const linkKeyFromGun = await getDdocDataByNodeKey(
      userNode,
      ddocId,
      { key: 'linkKey' },
      { supressToast: true }
    );
    if (linkKeyFromGun && linkKeyNonce && encryptedTitle) {
      const decryptedTitle = await WorkerInstance.decryptDdocTitle(
        encryptedTitle,
        ddocId,
        linkKeyNonce,
        linkKeyFromGun
      );
      if (decryptedTitle) {
        await updateTitleInCache(walletAddress, ddocId, decryptedTitle);
      }
      return decryptedTitle;
    }
  }
};
